import { Upload, Icon, message } from 'antd';
import React, { Component } from 'react';
import crypto from 'crypto';
import { OSSaccessKey, OSSsecretKey } from './config';
import './index.css';

export default class ImgUpload extends Component {
  state = {
    loading: false,
    imageUrl: this.props.value || '',
  };

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ imageUrl: this.props.value });
    }
  }

  getExtraData = file => {
    const date = new Date();
    date.setHours(date.getHours() + 1);
    const policyText = {
      expiration: date.toISOString(),
      conditions: [
        ["starts-with", "$key", ""],
        ["content-length-range", 0, 104857600]
      ]
    };
    const policyBase64 = Buffer.from(JSON.stringify(policyText)).toString('base64');
    const signature = crypto.createHmac('sha1', OSSsecretKey).update(policyBase64).digest('base64');

    return {
      key: file.ossKey,
      OSSAccessKeyId: OSSaccessKey,
      policy: policyBase64,
      Signature: signature,
    };
  };

  beforeUpload = file => {
    const suffix = file.name ? file.name.slice(file.name.lastIndexOf('.')) : '';
    const filename = Date.now() + suffix;
    file.ossKey = `banners/${filename}`;
    return true;
  };

  handleChange = info => {
    if (info.file.status === 'uploading') {
      this.setState({ loading: true });
      return;
    }
    if (info.file.status === 'done') {
      const file = info.file.originFileObj || info.file;
      const imageUrl = `https://cdn.zhitiaox.com/${file.ossKey}`;
      
      this.setState({
        imageUrl,
        loading: false,
      });
      
      if (this.props.onChange) {
        this.props.onChange(imageUrl);
      }
      message.success('Upload success');
    }
    if (info.file.status === 'error') {
      this.setState({ loading: false });
      message.error('Upload failed');
    }
  };

  render() {
    const uploadButton = (
      <div>
        <Icon type={this.state.loading ? 'loading' : 'plus'} />
        <div className="ant-upload-text">Upload</div>
      </div>
    );
    const { imageUrl } = this.state;
    return (
      <Upload
        name="file"
        action="https://cdn.zhitiaox.com"
        data={this.getExtraData}
        listType="picture-card"
        className="avatar-uploader"
        showUploadList={false}
        beforeUpload={this.beforeUpload}
        onChange={this.handleChange}
      >
        {imageUrl ? <img src={imageUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
      </Upload>
    );
  }
}
